/**
 * Pure, state-independent helper functions used by EvidenceTable.tsx.
 * Extracted verbatim (no logic changes) purely to reduce the size of the
 * main component file.
 */

// Builds a compound comparator function from a list of { key, order } sort
// options (up to 4), used to sort combined per-student column values.
export const getSortFunction = (sortOrder: any) => {
  const sortOptionLength = sortOrder.length;
  if (sortOptionLength == 1) {
    return (a: any, b: any) =>
      sortOrder[0].order == "Ascending"
        ? a[sortOrder[0].key] - b[sortOrder[0].key]
        : b[sortOrder[0].key] - a[sortOrder[0].key];
  } else if (sortOptionLength == 2) {
    return (a: any, b: any) =>
      (sortOrder[0].order == "Ascending"
        ? a[sortOrder[0].key] - b[sortOrder[0].key]
        : b[sortOrder[0].key] - a[sortOrder[0].key]) ||
      (sortOrder[1].order == "Ascending"
        ? a[sortOrder[1].key] - b[sortOrder[1].key]
        : b[sortOrder[1].key] - a[sortOrder[1].key]);
  } else if (sortOptionLength == 3) {
    return (a: any, b: any) =>
      (sortOrder[0].order == "Ascending"
        ? a[sortOrder[0].key] - b[sortOrder[0].key]
        : b[sortOrder[0].key] - a[sortOrder[0].key]) ||
      (sortOrder[1].order == "Ascending"
        ? a[sortOrder[1].key] - b[sortOrder[1].key]
        : b[sortOrder[1].key] - a[sortOrder[1].key]) ||
      (sortOrder[2].order == "Ascending"
        ? a[sortOrder[2].key] - b[sortOrder[2].key]
        : b[sortOrder[2].key] - a[sortOrder[2].key]);
  } else if (sortOptionLength == 4) {
    return (a: any, b: any) =>
      (sortOrder[0].order == "Ascending"
        ? a[sortOrder[0].key] - b[sortOrder[0].key]
        : b[sortOrder[0].key] - a[sortOrder[0].key]) ||
      (sortOrder[1].order == "Ascending"
        ? a[sortOrder[1].key] - b[sortOrder[1].key]
        : b[sortOrder[1].key] - a[sortOrder[1].key]) ||
      (sortOrder[2].order == "Ascending"
        ? a[sortOrder[2].key] - b[sortOrder[2].key]
        : b[sortOrder[2].key] - a[sortOrder[2].key]) ||
      (sortOrder[3].order == "Ascending"
        ? a[sortOrder[3].key] - b[sortOrder[3].key]
        : b[sortOrder[3].key] - a[sortOrder[3].key]);
  }
};

// Helper function to calculate min/max ranges from criteria array
export const calculateRangeFromCriteria = (criteria: Array<any>) => {
  let rangeMin: number | undefined;
  let rangeMax: number | undefined;

  criteria.forEach((criterion) => {
    if (criterion) {
      if (rangeMin === undefined || criterion.range_min! < rangeMin) {
        rangeMin = criterion.range_min;
      }
      if (rangeMax === undefined || criterion.range_max! > rangeMax) {
        rangeMax = criterion.range_max;
      }
    }
  });

  return { rangeMin, rangeMax };
};
